import { adEditionSelector } from 'common/selectors/appSelector';
import { adSiteSelector } from 'common/selectors/adsSelector';

export const ADS_CONFIG = 'ADS_CONFIG';
export const ADS_CONFIG_INVALIDATED = 'ADS_CONFIG_INVALIDATED';
export const ADS_INITIALIZED = 'ADS_INITIALIZED';
export const ADS_REFRESHED = 'ADS_REFRESHED';

function normalizePageId(id) {
    return id === 'home' ? 'index' : id;
}

export function setAdsConfig(id, config) {
    return {
        type: ADS_CONFIG,
        id,
        config
    };
}

export function initAdsConfig(id = '', tracking, kvps = {}, query = {}) {
    return (dispatch, getState) => {
        const pageId = normalizePageId(id);
        const state = getState();
        const adSite = adSiteSelector(state);
        const adEdition = adEditionSelector(state);
        const pgn = normalizePageId(((tracking && tracking.context && tracking.context.PageName) || '').toLowerCase());
        const { adprodtest, adtar, tstAdTar } = query;
        // NOTE: The `adtar`, `adprodtest` and `tstAdTar` query params are used to test Content|Overlay|Banner Ads
        // Example: ?adprodtest=usuaptest01 will return test Ad placeholders
        const adtarParam = (adprodtest || adtar || null);
        const tstAdTarParam = (tstAdTar || null);

        kvps.pgtyp = pageId;
        kvps.ed = adEdition;
        if (pgn) {
            kvps.pgn = pgn;
        }

        // NOTE: New key as of 05/2019
        // SEE: https://espnjira.disney.com/browse/WEWEB-2308
        if (tstAdTarParam) {
            kvps.tstAdTar = tstAdTarParam;
        } else if (adtarParam) {
            kvps.adtar = adtarParam;
        }

        const config = { level: `${adSite}/watch/${pageId}`, kvps };
        return dispatch(setAdsConfig(id, config));
    };
}

export function invalidateAdsConfig() {
    return {
        type: ADS_CONFIG_INVALIDATED
    };
}

export function adsInitialized() {
    return {
        type: ADS_INITIALIZED
    };
}

export function adsRefreshed() {
    return {
        type: ADS_REFRESHED
    };
}



// WEBPACK FOOTER //
// ./app/common/ads/actions/index.js